<script>
export default {
  name: "mapIcon",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M14.6668 5.99993V9.99993C14.6668 11.6666 14.3335 12.8333 13.5868 13.5866L9.3335 9.33326L14.4868 4.17993C14.6068 4.7066 14.6668 5.3066 14.6668 5.99993Z"
      stroke="#7A889B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.4868 4.17992L4.18016 14.4866C2.17349 14.0266 1.3335 12.6399 1.3335 9.99992V5.99992C1.3335 2.66659 2.66683 1.33325 6.00016 1.33325H10.0002C12.6402 1.33325 14.0268 2.17325 14.4868 4.17992Z"
      stroke="#7A889B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.5869 13.5866C12.8335 14.3333 11.6668 14.6666 10.0002 14.6666H6.00018C5.30685 14.6666 4.70684 14.6066 4.18018 14.4866L9.33352 9.33325L13.5869 13.5866Z"
      stroke="#7A889B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.16018 5.31998C4.61351 3.36665 7.54685 3.36665 8.00018 5.31998C8.26018 6.46665 7.54017 7.43998 6.90684 8.03998C6.44684 8.47998 5.72019 8.47998 5.25352 8.03998C4.62019 7.43998 3.89351 6.46665 4.16018 5.31998Z"
      stroke="#7A889B"
      stroke-width="1.5"
    />
    <path
      d="M6.06307 5.80013H6.06906"
      stroke="#7A889B"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style scoped></style>
